import styled from 'styled-components';

export const Base = styled.div`
	height: 100vh; /* fallback for older browsers */
	height: 100svh; /* small viewport height - excludes dynamic UI */
	/* Fill available inline size inside the main content area */
	width: -webkit-fill-available;
	width: -moz-available;
	width: stretch;
	position: absolute;
	background: ${(p) => p.theme.gray[0]};
	overflow: hidden;
	display: flex;
	flex-direction: column;
`;

export const SidebarToggle = styled.div`
	margin-left: 10px;
	margin-top: 10px;
`;

export const Content = styled.div`
	height: 100%;
	overflow-y: scroll;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Input = styled.div`
	// layout
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 120px;
	padding: 20px;
	width: 100%;
	max-width: 600px;

	// style
	text-align: center;
`;

export const Title = styled.div`
	font-size: 24px;
	font-weight: 500;
	color: ${(p) => p.theme.gray['1000']};
	margin-bottom: 28px;
	line-height: 1.35;
`;

export const Description = styled.div`
	font-size: 20px;
	color: ${(p) => p.theme.gray['600']};
	margin-bottom: 44px;
	max-width: 400px;
	line-height: 1.5;
`;

export const Buttons = styled.div`
	display: flex;
	gap: 14px;
`;

export const PromptInput = styled.div`
	width: 450px;
	margin-bottom: 28px;
	border: 1px solid ${(p) => p.theme.gray['200']};
	background: ${(p) => p.theme.gray['0']};
	text-align: left;
	position: relative;

	&:focus-within {
		border-color: ${(p) => p.theme.gray['400']};
		box-shadow: 0 0 0 2px ${(p) => p.theme.gray['100']};
	}
`;

export const CharCounter = styled.div`
	color: ${(p) => p.theme.gray['400']};
	padding-top: 2px;
	padding-bottom: 2px;
	padding-right: 4px;
	font-size: 12px;
	font-weight: 500;
	pointer-events: none;
	user-select: none;
	text-align: right;
`;
